"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportProgress = void 0;
// eslint-disable-next-line no-restricted-imports
const utils_1 = require("@juvare/common-form-ui/WidgetFormFile/Components/utils");
const IconPlaceholder_1 = require("@juvare/common-web-ui/IconPlaceholder");
const JuvareTheme_1 = require("@juvare/common-web-ui/JuvareTheme");
const hooks_1 = require("../../../../ui/hooks");
const utils_2 = require("../../../../ui/utils");
const CheckCircleOutline_1 = __importDefault(require("@mui/icons-material/CheckCircleOutline"));
const ErrorOutline_1 = __importDefault(require("@mui/icons-material/ErrorOutline"));
const FileDownload_1 = __importDefault(require("@mui/icons-material/FileDownload"));
const Timelapse_1 = __importDefault(require("@mui/icons-material/Timelapse"));
const material_1 = require("@mui/material");
const react_1 = __importDefault(require("react"));
const IMPORT_STATUS_CHECK_TIMEOUT = 3000;
const ImportProgressContent = ({ error, file, details }) => {
    function getIcon(status) {
        if (status === 'completed' || status === 'completedWithErrors') {
            return (react_1.default.createElement(IconPlaceholder_1.IconPlaceholder, { status: 'success' },
                react_1.default.createElement(CheckCircleOutline_1.default, null)));
        }
        else if (status === 'error') {
            return (react_1.default.createElement(IconPlaceholder_1.IconPlaceholder, { status: 'error' },
                react_1.default.createElement(ErrorOutline_1.default, null)));
        }
        else {
            return (react_1.default.createElement(IconPlaceholder_1.IconPlaceholder, { status: 'disabled' },
                react_1.default.createElement(Timelapse_1.default, null)));
        }
    }
    if (error) {
        return (react_1.default.createElement(material_1.Alert, { severity: 'error', icon: false }, "Import failed. Check your data file and try again."));
    }
    if (!details || (details === null || details === void 0 ? void 0 : details.status) === 'pending' || (details === null || details === void 0 ? void 0 : details.status) === 'preparing') {
        return (react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', padding: 1 } },
            react_1.default.createElement(material_1.CircularProgress, { size: 24 }),
            react_1.default.createElement("div", { style: { paddingLeft: 8 } },
                react_1.default.createElement(material_1.Typography, { variant: 'body1' }, "Initializing for file processing..."))));
    }
    const total = details.recordCount || 0;
    const processed = details.processedRecordCount || 0;
    return (react_1.default.createElement(material_1.Box, null,
        react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', gap: 2, pb: 2 } },
            getIcon(details.status),
            react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1, flexGrow: 1 } },
                react_1.default.createElement(material_1.Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, justifyContent: 'space-between' } },
                    react_1.default.createElement(material_1.Typography, { variant: 'subtitle2', sx: { color: JuvareTheme_1.themeColors.text.main }, "data-test": 'file-name' },
                        file.name,
                        " (",
                        (0, utils_1.humanFileSize)(file.size),
                        ")"),
                    react_1.default.createElement(material_1.Typography, { variant: 'body2', sx: { color: JuvareTheme_1.themeColors.text.subtle }, "data-test": 'import-progress' }, ` (${processed} of ${total})`)),
                react_1.default.createElement(material_1.LinearProgress, { variant: 'determinate', value: ((processed || 0) / total) * 100 }))),
        details.status === 'completedWithErrors' && (react_1.default.createElement(material_1.Alert, { severity: 'warning', icon: false, sx: { marginBottom: 2 } }, "Import completed with errors. Download the report for more information.")),
        details.status === 'error' && (react_1.default.createElement(material_1.Alert, { severity: 'error', icon: false }, "Import failed. Check your data file and try again.")),
        (details.status === 'completed' || details.status === 'completedWithErrors') && (react_1.default.createElement(material_1.Button, { startIcon: react_1.default.createElement(FileDownload_1.default, null), variant: 'outlined', onClick: () => (0, utils_2.downloadImportFile)({ id: details.id, downloadFileName: file.name }), "data-test": 'import-results-button' }, "Download Report"))));
};
const ImportProgress = (props) => {
    var _a, _b, _c;
    const importClient = (0, hooks_1.useImportClient)();
    const [details, setDetails] = react_1.default.useState();
    const [error, setError] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        var _a;
        const onError = () => setError(true);
        importClient
            .requestImport({
            entity: props.entity,
            content: props.file,
            contentType: 'text/csv',
            metadata: (_a = props.options) === null || _a === void 0 ? void 0 : _a.metadata,
        })
            .then((response) => checkImportStatus(response.id, importClient, setDetails, onError))
            .catch(onError);
    }, [importClient, props.entity, props.file, (_a = props.options) === null || _a === void 0 ? void 0 : _a.metadata]);
    const importFinished = details && (details.status === 'completed' || details.status === 'completedWithErrors' || details.status === 'error');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.DialogTitle, { id: props.ariaLabelledById }, (_c = (_b = props.options) === null || _b === void 0 ? void 0 : _b.dialogTitle) !== null && _c !== void 0 ? _c : 'Import'),
        react_1.default.createElement(material_1.DialogContent, { id: props.ariaDescribedById },
            react_1.default.createElement(ImportProgressContent, { error: error, details: details, file: props.file })),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(material_1.Button, { onClick: () => { var _a; return props.close((_a = props.options) === null || _a === void 0 ? void 0 : _a.onAfterImport); }, disabled: !importFinished, "data-test": 'close-dialog-button' }, "Close"))));
};
exports.ImportProgress = ImportProgress;
function checkImportStatus(id, importClient, resolve, reject, checkInterval) {
    importClient
        .getImportDetails({ id })
        .then((details) => {
        if (details.status === 'error' || details.status === 'completed' || details.status === 'completedWithErrors') {
            window.clearInterval(checkInterval);
        }
        else if (!checkInterval) {
            checkInterval = window.setInterval(() => checkImportStatus(id, importClient, resolve, reject, checkInterval), IMPORT_STATUS_CHECK_TIMEOUT);
        }
        resolve(details);
    })
        .catch(() => {
        window.clearInterval(checkInterval);
        reject();
    });
}
